import styled from 'styled-components';
import { createGradientOrSolid } from 'utils';
import { breakpoints } from 'styles/breakpoints';
import { EDynamicBundleType } from './constants';

export const StyledDynamicTemplate = styled.div`
  box-sizing: border-box;
  font-family: ${(props: any) => props.fontFamily};
  width: 100%;
  min-height: 166px;
  height: 100%;
  position: relative;

  background: ${(props: any) =>
    props.backgroundSrc
      ? `url("${props.backgroundSrc}")`
      : createGradientOrSolid(props.backgroundColor)};
  padding: 42px 8px 8px 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 0 12px 0 rgba(255, 255, 255, 0.8) inset;

  &[data-bundle-type='${EDynamicBundleType.LLC}'] {
    border-radius: 8px;
  }
  &[data-bundle-type='${EDynamicBundleType.HOV}'] {
    border-radius: 30px;
  }

  .tooltip-icon {
    height: 16px;
  }

  .dynamic-template {
    &__emblem-badge {
      position: absolute;
      left: 0;
      top: 4px;
      background-image: url(${(props: any) => props.badgeImage});
      background-repeat: no-repeat;
      z-index: 1000;
      height: 32px;

      @media (width <= ${breakpoints.mobileM}) {
        top: 5px;
        height: 28px;
      }

      img {
        max-height: 100%;
      }
    }

    &__tooltip {
      position: absolute;
      right: 8px;
      margin-top: 2px;

      .tooltip-container {
        height: 100%;
      }
    }

    &-products {
      display: flex;
      flex-direction: column;
      height: 100%;
      width: 100%;
      gap: 4px;
      justify-content: center;

      &__sub {
        height: 100%;
        gap: 4px;
        display: flex;
        flex-direction: column;
      }
    }
  }
` as any;

export const StyledRibbonWithImage = styled.div`
  position: absolute;
  left: -8px;
  top: -8px;
  z-index: 1000;

  ${StyledDynamicTemplate}[data-bundle-type='${EDynamicBundleType.LLC}'] & {
    height: 54px;
  }
  ${StyledDynamicTemplate}[data-bundle-type='${EDynamicBundleType.HOV}'] & {
    height: 68px;
  }

  img {
    max-height: 100%;
  }

  .ribbon-title {
    position: absolute;
    width: 100px;
    text-align: center;
    font-size: 10px;
    color: ${(props: any) => createGradientOrSolid(props.color)};

    ${StyledDynamicTemplate}[data-bundle-type='${EDynamicBundleType.LLC}'] & {
      font-weight: 500;
      top: 23px;
      right: -26px;
    }
    ${StyledDynamicTemplate}[data-bundle-type='${EDynamicBundleType.HOV}'] & {
      font-weight: 700;
      rotate: -46deg;
      top: 22px;
      right: -10px;
      text-shadow: 0px 1.6px 1.6px rgba(0, 0, 0, 0.3);
    }
  }
` as any;

export const StyledMainProduct = styled.div`
  box-sizing: border-box;
  width: 100%;
  height: 32px;
  border-radius: 4px;
  position: relative;
  display: flex;
  align-items: center;
  z-index: 1;

  .product-img {
    height: 64px;
    width: 64px;
    position: absolute;
    z-index: -1;
    left: 50%;
    transform: translateX(-50%);
    bottom: 18px;
    display: flex;
    justify-content: center;

    .image {
      position: absolute;
      height: 64px;
      width: auto;
    }
  }

  .content-container {
    width: 100%;
    height: 32px;
    background: rgba(49, 21, 132, 0.9);
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #fff;
    font-size: 12px;
    font-family: ${(props: any) => props.fontFamily};
    min-width: 0;

    ${StyledDynamicTemplate}[data-bundle-type='${EDynamicBundleType.LLC}'] & {
      background: rgba(49, 21, 132, 0.9);
    }
    ${StyledDynamicTemplate}[data-bundle-type='${EDynamicBundleType.HOV}'] & {
      background: rgba(121, 80, 217, 0.9);
    }

    .stroked-container,
    .quantity-container {
      padding: 0 4px;
      min-width: 0;
      z-index: 1;
      width: 100%;
      text-align: center;
      justify-content: center;
    }

    .quantity-container {
      &__value {
        display: flex !important;
        justify-content: center;
        align-items: center;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        color: #fff;
        width: calc(100% + 20px);
        text-transform: uppercase;
      }
    }

    .stroked-container {
      &__value {
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        color: #fff;
        width: 100%;
        text-decoration: line-through;
        text-decoration-color: #f00;
      }
    }

    .tooltip-icon {
      height: 16px;
    }
  }
` as any;

export const StyledSubProduct = styled.div<{
  isTooltipShown: boolean;
}>`
  box-sizing: border-box;
  width: 100%;
  height: 32px;
  border-radius: 4px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;

  ${StyledDynamicTemplate}[data-bundle-type='${EDynamicBundleType.LLC}'] & {
    background: #311584;
  }
  ${StyledDynamicTemplate}[data-bundle-type='${EDynamicBundleType.HOV}'] & {
    background: rgba(121, 80, 217, 0.9);
  }

  .product-info {
    display: flex;
    align-items: center;
    padding-left: 4px;
    width: 100%;

    .product-img {
      min-width: 28px;
      max-height: 28px;
      display: flex;
      justify-content: center;
      position: relative;

      .image {
        height: 28px;
        width: 28px;
      }
    }

    .price-container {
      padding-left: 4px;
      padding-right: ${(props: any) => (props.isTooltipShown ? '22px' : '4px')};
      min-width: 0;
      width: 100%;

      .quantity-container {
        &__value {
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          color: #fff;
          width: 100%;
          text-transform: uppercase;
        }
      }
    }
  }

  .tooltip-icon {
    height: 16px;
  }
` as any;

export const StyledPriceButton = styled.div`
  margin-top: 8px;
  font-family: ${({ fontFamily }: any) => fontFamily};
  background: ${({ bundleButtonColor }: any) =>
    bundleButtonColor && createGradientOrSolid(bundleButtonColor)};
  display: flex;
  direction: ltr;
  justify-content: center;
  align-items: center;
  color: ${({ bundleButtonTextColor }: any) => bundleButtonTextColor};
  position: relative;

  ${StyledDynamicTemplate}[data-bundle-type='${EDynamicBundleType.LLC}'] & {
    border-radius: 4px;
    width: 100%;
    height: 31px;
    border-bottom: 1px solid #31d9f8;
    box-shadow: 0px -1px 4.3px 0px #14fd29 inset;
  }
  ${StyledDynamicTemplate}[data-bundle-type='${EDynamicBundleType.HOV}'] & {
    border-radius: 14px;
    min-width: 120px;
    height: 28px;
    border: 1px solid #153831;
    box-shadow: 0 0.04rem 0.12rem 0.06rem #afff74 inset,
      0 0 0.22rem 0.02rem rgba(39, 167, 18, 0.6) inset,
      0 0.12rem 0.14rem 0 rgba(0, 0, 0, 0.3);
  }

  .totalPrice {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 5px;
    z-index: 10;
    white-space: nowrap;
    font-weight: 700;
    width: 100%;

    span,
    .final-price,
    .stroked {
      text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.3),
        -0.5px 0.5px 0 rgb(0, 101, 43), 0.5px -0.5px 0 rgb(0, 101, 43),
        -0.5px -0.5px 0 rgb(0, 101, 43), 0.5px 0.5px 0 rgb(0, 101, 43);
    }

    .stroked {
      font-size: 12px;
    }
  }
` as any;
